import { useState } from "react";
import { Tag, Avatar } from "antd";
import { ChevronDown, ChevronRight, ListTodo } from "lucide-react";

export default function HistoryList({ history, statusColor }: any) {
    const [openIds, setOpenIds] = useState<number[]>([]);

    const historyMock = [
        {
            id: 1,
            time: "00:30 10/04/2026",
            user: "Phan",
            changes: [
                { field: "status", from: "Mới", to: "Đã liên hệ" },
                { field: "handler", from: "Huỳnh Anh Khánh", to: "Võ Ngọc Vy" },
                { field: "address", from: "Cần Thơ", to: "HCM" },
            ],
            from: "Mới",
            to: "Đã liên hệ",
            text: "Khách hàng đã được liên hệ và xác nhận thông tin.",
        },
        {
            id: 2,
            time: "00:31 10/04/2026",
            user: "Phan",
            changes: [
                { field: "status", from: "Mới", to: "Đã liên hệ" },
                { field: "handler", from: "Huỳnh Anh Khánh", to: "Võ Ngọc Vy" },
                { field: "address", from: "Cần Thơ", to: "HCM" },
            ],
            from: "Đã liên hệ",
            to: "Đang chăm sóc",
            text: "Khách hàng đang được chăm sóc.",
        },
        {
            id: 3,
            time: "00:32 10/04/2026",
            user: "Phan",
            changes: [
                { field: "status", from: "Mới", to: "Đã liên hệ" },
                { field: "handler", from: "Huỳnh Anh Khánh", to: "Võ Ngọc Vy" },
                { field: "address", from: "Cần Thơ", to: "HCM" },
            ],
            from: "Đang chăm sóc",
            to: "Đã chuyển đổi",
            text: "Khách hàng đã chuyển đổi trạng thái.",
        },
        {
            id: 4,
            time: "00:33 10/04/2026",
            user: "Phan",
            changes: [
                { field: "status", from: "Mới", to: "Đã liên hệ" },
                { field: "handler", from: "Huỳnh Anh Khánh", to: "Võ Ngọc Vy" },
                { field: "address", from: "Cần Thơ", to: "HCM" },
            ],
            from: "Đã chuyển đổi",
            to: "Không tiềm năng",
            text: "Khách hàng không còn tiềm năng.",
        },
        {
            id: 5,
            time: "00:35 10/04/2026",
            user: "Phan",
            changes: [
                { field: "status", from: "Mới", to: "Đã liên hệ" },
                { field: "handler", from: "Huỳnh Anh Khánh", to: "Võ Ngọc Vy" },
                { field: "address", from: "Cần Thơ", to: "HCM" },
            ],
            from: "Huỳnh Anh Khánh",
            to: "Võ Ngọc Vy",
            text: "Nhân sự phụ trách đã được thay đổi.",
        },
        {
            id: 6,
            time: "00:36 10/04/2026",
            user: "Phan",
            changes: [
                { field: "status", from: "Mới", to: "Đã liên hệ" },
                { field: "handler", from: "Huỳnh Anh Khánh", to: "Võ Ngọc Vy" },
                { field: "address", from: "Cần Thơ", to: "HCM" },
            ],
            text: "Khách hàng hỏi về sản phẩm A, cần tư vấn thêm.",
        },
        {
            id: 7,
            time: "00:38 10/04/2026",
            user: "Phan",
            changes: [
                { field: "status", from: "Mới", to: "Đã liên hệ" },
                { field: "handler", from: "Huỳnh Anh Khánh", to: "Võ Ngọc Vy" },
                { field: "address", from: "Cần Thơ", to: "HCM" },
            ],
            from: "Cần Thơ",
            to: "Hồ Chí Minh",
            text: "Địa chỉ khách hàng đã được cập nhật.",
        },
        {
            id: 8,
            time: "00:40 10/04/2026",
            user: "Phan",
            changes: [
                { field: "status", from: "Mới", to: "Đã liên hệ" },
                { field: "handler", from: "Huỳnh Anh Khánh", to: "Võ Ngọc Vy" },
                { field: "address", from: "Cần Thơ", to: "HCM" },
            ],
            from: "Không tiềm năng",
            to: "Mới",
            text: "Khách hàng đã được đặt lại trạng thái.",
        },
    ];

    const toggle = (id: number) => {
        setOpenIds((prev) =>
            prev.includes(id)
                ? prev.filter((i) => i !== id)
                : [...prev, id]
        );
    };

    return (
        <>
            <div className="flex items-center justify-between border-b border-slate-300 pb-3.5 mb-6 mt-2">
                <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider flex items-center flex items-center gap-2">
                    <ListTodo size={16} /> Dòng thời gian lịch sử chăm sóc
                </h3>
                <span className="text-xs text-slate-400 font-bold" x-text="'Tổng cộng: ' + historyLogs.length + ' bản ghi'">Tổng cộng: 3 bản ghi</span>
            </div>
            <div className="relative pl-4 pr-4 py-4">

                {/* LINE */}
                <div className="absolute left-4 top-0 bottom-0 w-[2px] bg-gray-200" />

                {(history?.length ? history : historyMock).map((item: any) => {
                    const isOpen = openIds.includes(item.id);

                    return (
                        <div key={item.id} className="relative mb-6">

                            {/* DOT */}
                            <div className="absolute left-[7px] top-3 -translate-x-1/2 w-3 h-3 bg-white rounded-full border-4 border-[#3e91ab] z-10" />

                            {/* CONTENT */}
                            <div className="bg-gray-50 rounded-lg p-3 ml-4">

                                {/* HEADER */}
                                <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() => toggle(item.id)}
                                >
                                    <div className="flex items-center gap-2 text-sm text-gray-600">

                                        {/* ICON */}
                                        {isOpen ? (
                                            <ChevronDown size={16} />
                                        ) : (
                                            <ChevronRight size={16} />
                                        )}

                                        {/* title */}
                                        <span className="text-sm font-bold text-slate-800">{item.text}</span>
                                    </div>

                                    {/* USER */}
                                    <div className="flex items-center gap-2">
                                        <span className="text-xs text-slate-400 font-medium">{item.time}</span>
                                    </div>
                                </div>

                                {/* BODY */}
                                {isOpen && (
                                    <div className="mt-3 text-sm pl-5 space-y-1">

                                        {item.changes?.map((change: any, index: number) => {
                                            if (change.field === "status") {
                                                return (
                                                    <div key={index}>
                                                        Trạng thái: Từ{" "}
                                                        <Tag color={statusColor[change.from]}>
                                                            {change.from}
                                                        </Tag>{" "}
                                                        →{" "}
                                                        <Tag color={statusColor[change.to]}>
                                                            {change.to}
                                                        </Tag>
                                                    </div>
                                                );
                                            }

                                            if (change.field === "handler") {
                                                return (
                                                    <div key={index}>
                                                        Người xử lý: <b>{change.from}</b> → <b>{change.to}</b>
                                                    </div>
                                                );
                                            }

                                            if (change.field === "address") {
                                                return (
                                                    <div key={index}>
                                                        Địa chỉ: <b>{change.from}</b> → <b>{change.to}</b>
                                                    </div>
                                                );
                                            }

                                            if (change.field === "note") {
                                                return (
                                                    <div key={index}>
                                                        Ghi chú: {change.text}
                                                    </div>
                                                );
                                            }

                                            return null;
                                        })}

                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}